module.exports = __webpack_public_path__ + "img/career-guidance.3e86712d.svg";